<template>
  <div>
    <navigation adaption/>
    <div class="page face-authentication">
      <div class="background">
        <img class="back" src="./images/back.png" alt="" @click="goBack">
        <p class="title">身份验证</p>
      </div>

      <div class="authentication-step">
        <div class="steps">
          <div class="step-item">
            <i class="custom-icon phone"></i>
            <span>请竖直紧握手机</span>
          </div>

          <div class="step-item">
            <i class="custom-icon face"></i>
            <span>请勿遮挡脸部</span>
          </div>

          <div class="step-item">
            <i class="custom-icon light"></i>
            <span>请在光线良好的环境下做测试</span>
          </div>

          <div class="step-item">
            <i class="custom-icon portrait"></i>
            <span>请将人脸放在人像框内</span>
          </div>
        </div>

        <nd-button class="start-authentication" @click="startAuth" :disabled="false">开始验证</nd-button>
      </div>
    </div>

    <nd-dialog
      v-model="detentionVisible"
      class="detention-dialog"
      :footer="false"
    >
      <div class="detention-content">
        <div class="header">
          <p>填写简单的信息，最高即可获得</p>
          <p>5万额度！真的要放弃吗？</p>
        </div>
        <ul class="body">
          <li
            v-for="(item, index) in giveUpReason"
            :key="index"
            @click="giveUp(index + 1)"
          >
            {{ item }}
          </li>
        </ul>
        <button class="footer" @click="detentionVisible = false">
          继续完成，拿额度
        </button>
      </div>
    </nd-dialog>
    <detention v-model="detentionVisible"></detention>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { jsBridge, hasNativeMethod } from '@/assets/jsBridge'
import { judgeClientSystem, getKey, versionStringCompare } from '@/assets/utils'
export default {
  name: 'face-authentication',

  description: '刷脸活体认证',

  customReadyNotify: true,

  computed: {
    ...mapState('user', ['userInfo'])
  },
  components: {
    detention: () => import('./components/detention.vue')
  },

  data () {
    return {
      detentionVisible: false,
      form: {
        faceTerminal: 'H5',
        faceType: 'FACE_ID_CHECK',
        mobileNumber: '',
        deviceIp: '',
        productIdentifier: ''
      },
      query: this.$route.query,
      giveUpReason: [
        '我再逛逛',
        '放弃免费额度'
      ]
    }
  },
  created () {
    if (this.$route.query.step === 'PRE_CREDIT_LIVING_H5') {
      window.history.pushState({}, '', window.location.href)
      window.addEventListener('popstate', () => {
        this.detentionVisible = true
      })
    }
    this.getUserInfoX().then(() => {
      this.$bus.$emit('ready')
      if (this.query.newSignature) {
        this.verifyAuthResult()
      }
    }).catch(() => {
      this.$bus.$emit('error')
    })
  },
  methods: {
    ...mapActions('authentication', [
      'getTencentTokenX',
      'verifyTencetLivenessResultX',
      'onlyPreApply'
    ]),

    ...mapActions('user', [
      'getUserInfoX'
    ]),
    ...mapActions('apiDiversion', ['creditApply']),

    goBack () {
      if (judgeClientSystem() !== 'IOS' && hasNativeMethod('exit')) {
        // 是android 并且任务栈只有当前页面
        jsBridge('exit')
      } else {
        this.$router.go(-1)
      }
    },
    async startAuth () {
      this.$report({
        id: 10095
      })
     
      // 针对颜值贷用户做单独的提示
      const channel = getKey('channel') || this.$route.query.channel || 'official'
      if (judgeClientSystem() === 'Android' && channel === 'H5-YZD') {
        return this.$router.push('/authentication/face-error')
      }
      let bool = true
      let faceVersion = ''
      if (judgeClientSystem() !== 'IOS' && hasNativeMethod('openCameraPermission')) {
        if (versionStringCompare('1.7.8.8', getKey('appVersion')) <= 0) {
          faceVersion = 'V2'
        }
        const res = await jsBridge('openCameraPermission', { needCamera: 'Y' })
        if (res.code !== 'OK') {
          bool = false
        }
      } else {
        faceVersion = 'V2'
      }
      if (bool) {
        const params = {
          way: 'H5', faceVersion
        }
        const { sceneType } = this.$route.query
        if (sceneType) {
          params.sceneType = sceneType
          params.sceneNo = this.$storage.get('applySerialNo')
        }
      
        const response = await this.getTencentTokenX({ ...params })
        if (response.data.success) {
          if (response.data.data.sign) {
            this.$storage.set('faceSign', response.data.data.sign)
          }
          this.redirectTencent(response.data.data)
        }
      }
    },

    // 跳转腾讯
    redirectTencent (data) {
      const params = {
        webankAppId: data.appId,
        version: '1.0.0',
        nonce: data.nonce,
        orderNo: data.orderNo,
        h5faceId: data.faceId,
        url: `${window.location.href}`,
        resultType: '',
        userId: data.userId,
        sign: data.sign,
        from: 'browser',
        redirectType: '1'
      }

      const queryString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&')

      // const url = 'https://kyc.qcloud.com/api/web/login?' + queryString
      // const url = 'https://ida.webank.com/api/web/login?' + queryString

      window.location.href = `${data.faceHost}/api/web/login?${queryString}`
    },

    // 验证结果
    async verifyAuthResult () {
      const params = Object.assign({}, this.form, {
        sign: this.$storage.get('faceSign'),
        tencentSign: this.query.newSignature,
        orderNo: this.query.orderNo
      })
      const response = await this.verifyTencetLivenessResultX(params)
      localStorage.removeItem('faceSign')
      if (response.success) {
        this.$message('活体认证成功')
        const { from, to, step } = this.$route.query
        if (step) {
          const params = {}
          if (step === 'PRE_CREDIT_LIVING_H5') {
            params.creditFLowType = 'H5_CREDIT'
          }
          const { success } = await this.onlyPreApply(params)
          if (success) {
            if (step === 'PRE_CREDIT_LIVING') {
              this.$router.replace('/middle/limit')
              return
            }

            if (step === 'PRE_CREDIT_LIVING_H5') {
              this.$router.replace('/authentication/base-h5-credit')
              return
            }
          } 
        }
        if (from || to) {
          const configIds = getKey('configIds')
          this.$sensors.track('Withdraw_Element_Click', { product_type: 'diversion', product_code: JSON.stringify(configIds) })
        }
        // 从一件申请的页面过来
        if (['riverDiversion', 'apiAuthResult'].includes(to)) {
          const { success, data } = await this.creditApply({
            configIds: getKey('configIds')
          })

          if (success) {
            // 多个申请去导流主页
            if (to === 'riverDiversion') {
              return this.$router.replace('/river/diversion?tabActive=1')
            }

            // 单个申请去结果页
            if (to === 'apiAuthResult') {
              return this.$router.replace({
                path: '/authentication/api-result',
                query: {
                  applyNo: data.applyNo
                }
              })
            }
          }
        }

        // 针对api产品 有一个from参数
        if (from) {
          return this.$router.replace({ name: from, query: { result: 'success' } })
        }

        if (this.$storage.get('faceSource') === 'consult') {
          this.$router.replace({
            path: '/repayment/consult/preview',
            query: {
              result: 'PASS'
            }
          })
        } else {
          this.$router.replace({
            path: '/withdraw/preview',
            query: {
              result: 'PASS'
            }
          })
        }
        this.$report({
          id: 10096,
          args: {
            succeed: 1
          }
        })
        this.$statistics('FACE_SUC')
      } else {
        this.$statistics('FACE_FAIL', {
          comment: response.msg
        })
        this.$message(response.msg)
        this.$report({
          id: 10096,
          args: {
            succeed: 0
          }
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

    .face-authentication {
        height: 100vh;
        position: relative;

        .background {
            width: 100%;
            height: 697px;
            background-size: 100% 100%;
            background-image: url(./images/bg.png);
            position: absolute;
            top: 0;
            z-index: 0;
            .back {
                width: 50px;
                height: 50px;
                z-index: 1;
                margin-top: 87px;
                margin-left: 54px;
            }
            .title {
                width: 100%;
                margin-top: 62px;
                color: white;
                font-size: 74px;
                font-weight: 300;
                padding-left: 56px;
            }
        }

        .authentication-step {
            width: 660px;
            margin: 0 45px;
            padding-bottom: 50px;
            background-color: #FFF;
            border-radius: 38px;
            overflow: hidden;
            box-shadow: 0 2px 8px 0 rgba(233,233,233,1), 0 12px 16px 0 rgba(0, 0, 0, 0.05);
            position: relative;
            z-index: 1;
            top: 379px;
            .steps {
                padding: 0 70px;
                margin-top: 48px;
                .step-item {
                    line-height: 110px;
                    position: relative;

                    .custom-icon {
                        width: 50px;
                        height: 50px;
                        display: inline-block;
                        position: absolute;
                        left: 0;
                        top: 30px;
                        background-size: 100% 100%;
                        &.phone {
                            background-image: url(./images/icon_phone.png);
                        }
                        &.face {
                            background-image: url(./images/icon_face.png);
                        }
                        &.light {
                            background-image: url(./images/icon_light.png);
                        }
                        &.portrait {
                            background-image: url(./images/icon_portrait.png);
                        }
                    }

                    span {
                        margin-left: 80px;
                        font-family: 'PingFangSC-Regular';
                        font-weight: 400;
                        font-size: 28px;
                        color: #666;
                    }
                }
            }

            .start-authentication {
                width: 508px;
                margin: 0 76px;
                margin-top: 150px;
            }
        }
    }
</style>
